import React, { Component, DropdownMenu, MenuItem } from 'react';
import { Menu, Table, Progress, Dropdown, Button } from 'antd';
import { connect } from 'react-redux';
import './providerDeshbord.scss'
import _ from 'lodash';
import HomeCaregory from '../../../modules/user/component/homeCaregory'
import { Link } from "react-router-dom";
import RequestIcon from "../../../images/request.png";
import ProgressIcon from "../../../images/progress.png";
import ComplatedIcon from "../../../images/complate.png";
import MissedIcon from "../../../images/missed-call.png";
import Graph from "../../../images/graph.png";
import Avatar from "../../../images/img_avatar.png";
import logo from "../../../images/logo-image.png";
import Header from "../../../layout/DefaultLayout/Header";

const columns = [
  {
    title: 'Date',
    dataIndex: 'date',
  },
  {
    title: 'Bid Number',
    dataIndex: 'bidNumber',
  },
  {
    title: 'Bid Price',
    dataIndex: 'bidPrice',
  },
  {
    title: 'Last Updated',
    dataIndex: 'lastUpdated',
  },
  {
    title: 'Status',
    dataIndex: 'status',
  },

  {
    title: 'Action',
    dataIndex: 'action',
  },

];
const columns1 = [
  {
    title: 'Date',
    dataIndex: 'date',
  },
  {
    title: 'TODO',
    dataIndex: 'todo',
  },
  {
    title: 'TODO',
    dataIndex: 'todo',
  },
  {
    title: 'TODO',
    dataIndex: 'todo',
  },
  {
    title: 'TODO',
    dataIndex: 'todo',
  },

];

const data = [
  {
    key: '1',
    date: "16/10/2020",
    bidNumber: "#ED102453",
    bidPrice: "1024",
    lastUpdated: "8/10/2020",
    status: "Active",
    action: "DELETE"
  },
  {
    key: '2',
    date: "16/10/2020",
    bidNumber: "#ED102453",
    bidPrice: "1024",
    lastUpdated: "8/10/2020",
    status: "Active",
    action: "DELETE"
  },
  {
    key: '3',
    date: "16/10/2020",
    bidNumber: "#ED102453",
    bidPrice: "1024",
    lastUpdated: "8/10/2020",
    status: "Active",
    action: "DELETE"
  },
  {
    key: '4',
    date: "16/10/2020",
    bidNumber: "#ED102453",
    bidPrice: "1024",
    lastUpdated: "8/10/2020",
    status: "Active",
    action: "DELETE"
  },
];
/* eslint eqeqeq: 0 */
export class ProviderDeshbord extends Component {
  constructor() {
    super();
  }

  render() {
    const { user } = this.props
    return (
      <div>
        <Header></Header>
        <div className="services-background">
          <div className="deshbord-container">
            <div className="service-heading-txt">Services</div>
          </div>
          <HomeCaregory></HomeCaregory>
          <div className="deshbord-container">
            <div className="row">
              <div className="col-sm-12 col-md-3 col-xs-12">
                <div className="request-box">
                  <img src={RequestIcon} className="card-icon" alt="" />
                  <div className="cards-heading">Total Request</div>
                  <div className="cards-value">1234</div>
                </div>
              </div>
              <div className="col-sm-12 col-md-3 col-xs-12">
                <div className="progress-box">
                  <img src={ProgressIcon} className="card-icon" alt="" />
                  <div className="cards-heading">Total In-Progress</div>
                  <div className="cards-value">134</div>
                </div>
              </div>
              <div className="col-sm-12 col-md-3 col-xs-12">
                <div className="complate-box">
                  <img src={ComplatedIcon} className="card-icon" alt="" />
                  <div className="cards-heading">Total Complated</div>
                  <div className="cards-value">11234</div>
                </div>
              </div>
              <div className="col-sm-12 col-md-3 col-xs-12">
                <div className="missed-box">
                  <img src={MissedIcon} className="card-icon" alt="" />
                  <div className="cards-heading">Total Missed</div>
                  <div className="cards-value">234</div>
                </div>
              </div>
            </div>

            <div className="graph-box">
              <img src={Graph} className="graph-icon" alt="" />
            </div>


            <div className="table-heading-txt">Biding</div>
            <Table columns={columns} dataSource={data} />

            <div className="table-heading-txt">Transctions</div>
            <Table columns={columns1} dataSource={data} />



            <div className="graph-box">
              <div className="rating-main-box">
                <div className="rating-heading">Customer Review</div>

                <div className="rating-container">
                  <img src={Avatar} className="review-avatar-image" alt="" />
                  <div className="custmer-name-box">
                    <div className="custmer-name-txt">Suresh</div>
                    <div className="custmer-name-subtxt">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</div>
                  </div>
                  <div className="reting-box">
                    <span className="fa fa-star checked"></span>
                    <span className="fa fa-star checked"></span>
                    <span className="fa fa-star checked"></span>
                    <span className="fa fa-star"></span>
                    <span className="fa fa-star"></span>
                  </div>
                </div>

                <div className="rating-container">
                  <img src={Avatar} className="review-avatar-image" alt="" />
                  <div className="custmer-name-box">
                    <div className="custmer-name-txt">Suresh</div>
                    <div className="custmer-name-subtxt">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</div>
                  </div>
                  <div className="reting-box">
                    <span className="fa fa-star checked"></span>
                    <span className="fa fa-star checked"></span>
                    <span className="fa fa-star checked"></span>
                    <span className="fa fa-star"></span>
                    <span className="fa fa-star"></span>
                  </div>
                </div>

                <div className="rating-container">
                  <img src={Avatar} className="review-avatar-image" alt="" />
                  <div className="custmer-name-box">
                    <div className="custmer-name-txt">Rohit</div>
                    <div className="custmer-name-subtxt">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</div>
                  </div>
                  <div className="reting-box">
                    <span className="fa fa-star checked"></span>
                    <span className="fa fa-star checked"></span>
                    <span className="fa fa-star checked"></span>
                    <span className="fa fa-star"></span>
                    <span className="fa fa-star"></span>
                  </div>
                </div>

                <div className="rating-container">
                  <img src={Avatar} className="review-avatar-image" alt="" />
                  <div className="custmer-name-box">
                    <div className="custmer-name-txt">Pooja</div>
                    <div className="custmer-name-subtxt">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</div>
                  </div>
                  <div className="reting-box">
                    <span className="fa fa-star checked"></span>
                    <span className="fa fa-star checked"></span>
                    <span className="fa fa-star checked"></span>
                    <span className="fa fa-star"></span>
                    <span className="fa fa-star"></span>
                  </div>
                </div>

                <div className="rating-container">
                  <img src={Avatar} className="review-avatar-image" alt="" />
                  <div className="custmer-name-box">
                    <div className="custmer-name-txt">Dee</div>
                    <div className="custmer-name-subtxt">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</div>
                  </div>
                  <div className="reting-box">
                    <span className="fa fa-star checked"></span>
                    <span className="fa fa-star checked"></span>
                    <span className="fa fa-star checked"></span>
                    <span className="fa fa-star"></span>
                    <span class="fa fa-star"></span>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>

      </div >

    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user
  }
}

export default connect(
  mapStateToProps
)(ProviderDeshbord);